import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../api";

const FALLBACK = {
  id: "USR-0001", name: "Sultan Al-Farsi", email: "s.alfarsi@acmecorp.com",
  role: "Chief Security Officer", initials: "SA", status: "Active",
};

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("grc_user");
    if (stored) {
      try { setUser(JSON.parse(stored)); } catch { localStorage.removeItem("grc_user"); }
    }
    setLoading(false);
  }, []);

  const login = async (email) => {
    let profile = FALLBACK;
    try {
      const res = await api.login(email);
      if (res && res.user && res.user.role) profile = res.user;
    } catch (e) { /* demo fallback */ }
    // Always present as Chief Security Officer for the demo persona
    profile = { ...profile, role: "Chief Security Officer" };
    localStorage.setItem("grc_user", JSON.stringify(profile));
    setUser(profile);
    return profile;
  };

  const logout = () => { localStorage.removeItem("grc_user"); setUser(null); };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
